import { render } from "./IntegrationSerie.vue?vue&type=template&id=50701ac5"
import script from "./IntegrationSerie.vue?vue&type=script&lang=js"
export * from "./IntegrationSerie.vue?vue&type=script&lang=js"

import "./IntegrationSerie.vue?vue&type=style&index=0&id=50701ac5&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__